module.exports = __webpack_public_path__ + "static/media/logo.62f3e87e.png";